import { useFlags } from 'launchdarkly-react-client-sdk';
import { mapLaunchDarklyFlagToFeatureFlag } from './featureFlags';

export const useLaunchDarklyFlags = () => {
  const ldFlags = useFlags();

  // Map LaunchDarkly flags to our feature flag keys
  return mapLaunchDarklyFlagToFeatureFlag(ldFlags);
};
